var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTextbooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 42.976,
    height: 25.702,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_textbooks",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(332.345 227.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223-2",
    "data-name": "Group 223",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21936",
    "data-name": "Path 21936",
    d: "M21.106,24.407s2.658-3.93,10.174-3.93,10.4,3.7,10.4,3.7V3.942s-2.889-3.7-10.4-3.7S21.068,4.154,21.068,4.154h-.209S18.163.243,10.648.243s-10.4,3.7-10.4,3.7V24.176s2.889-3.7,10.4-3.7,10.174,3.93,10.174,3.93Z",
    transform: "translate(0.526 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21937",
    "data-name": "Path 21937",
    d: "M8.338,1.933c-5,0-6.68,1.744-6.68,1.744V18.012l2.49-.908,5.459-.187,4.326,1.07,3.424,2.282.538,1.051V5.047A14.752,14.752,0,0,0,8.338,1.933",
    transform: "translate(3.589 4.184)",
    fill: "#946290"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21938",
    "data-name": "Path 21938",
    d: "M17.278,1.933c-7.516,0-10.4,3.7-10.4,3.7V20.594c.579-.721,3.427-3.775,10.057-3.775,7.516,0,10.4,3.7,10.4,3.7V5.648c-.658-.788-3.547-3.715-10.053-3.715",
    transform: "translate(14.876 4.184)",
    fill: "#4b89c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21939",
    "data-name": "Path 21939",
    d: "M21.632,25.7h-.285a.764.764,0,0,1-.636-.339c-.1-.142-2.576-3.592-9.538-3.592-7,0-9.772,3.373-9.8,3.408A.771.771,0,0,1,0,24.7V4.468A.75.75,0,0,1,.165,4c.127-.165,3.209-4,11.009-4,6.063,0,9.167,2.443,10.316,3.626C22.635,2.443,25.743,0,31.806,0c7.8,0,10.883,3.832,11.009,4a.769.769,0,0,1,.165.472V24.7a.77.77,0,0,1-1.377.475c-.025-.032-2.8-3.4-9.8-3.4-6.962,0-9.436,3.449-9.541,3.595a.768.768,0,0,1-.633.335M11.174,20.234c6.12,0,9.2,2.5,10.316,3.674,1.114-1.177,4.2-3.674,10.316-3.674,4.984,0,8.044,1.566,9.633,2.737V4.766c-.684-.7-3.579-3.228-9.633-3.228-7.028,0-9.553,3.544-9.579,3.582a.773.773,0,0,1-.633.332h-.209a.773.773,0,0,1-.633-.332c-.1-.146-2.611-3.582-9.579-3.582-6.05,0-8.946,2.525-9.636,3.228V22.971C3.13,21.8,6.19,20.234,11.174,20.234",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 1.538,
    height: 20.161,
    transform: "translate(20.715 4.731)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21940",
    "data-name": "Path 21940",
    d: "M7.623,6.253a.387.387,0,0,1-.225-.7,14.874,14.874,0,0,1,8.756-2.427,16.684,16.684,0,0,1,8.234,1.914.387.387,0,1,1-.38.674A15.937,15.937,0,0,0,16.155,3.9a14.134,14.134,0,0,0-8.31,2.285.375.375,0,0,1-.222.07",
    transform: "translate(15.661 6.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21941",
    "data-name": "Path 21941",
    d: "M7.492,7.485a.379.379,0,0,1-.316-.165.389.389,0,0,1,.092-.541,15.626,15.626,0,0,1,9.183-2.541,17.467,17.467,0,0,1,8.636,2.006.385.385,0,0,1,.149.525.393.393,0,0,1-.528.152,16.723,16.723,0,0,0-8.256-1.908,14.859,14.859,0,0,0-8.737,2.4.382.382,0,0,1-.222.07",
    transform: "translate(15.377 9.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21942",
    "data-name": "Path 21942",
    d: "M7.623,8.52A.389.389,0,0,1,7.4,7.814,14.877,14.877,0,0,1,16.155,5.39,16.726,16.726,0,0,1,24.388,7.3a.388.388,0,0,1-.38.677,15.937,15.937,0,0,0-7.854-1.813A14.11,14.11,0,0,0,7.845,8.45a.375.375,0,0,1-.222.07",
    transform: "translate(15.661 11.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21943",
    "data-name": "Path 21943",
    d: "M1.09,6.253a.383.383,0,0,1-.316-.165A.388.388,0,0,1,.866,5.55,14.886,14.886,0,0,1,9.625,3.123a16.68,16.68,0,0,1,8.231,1.914.387.387,0,1,1-.38.674A15.932,15.932,0,0,0,9.625,3.9,14.137,14.137,0,0,0,1.312,6.183a.382.382,0,0,1-.222.07",
    transform: "translate(1.524 6.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21944",
    "data-name": "Path 21944",
    d: "M1.09,7.386a.383.383,0,0,1-.316-.165A.392.392,0,0,1,.866,6.68,14.912,14.912,0,0,1,9.625,4.256a16.721,16.721,0,0,1,8.231,1.911.388.388,0,0,1-.38.677A15.932,15.932,0,0,0,9.625,5.031,14.114,14.114,0,0,0,1.312,7.316a.382.382,0,0,1-.222.07",
    transform: "translate(1.524 9.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21945",
    "data-name": "Path 21945",
    d: "M1.09,8.52a.383.383,0,0,1-.316-.165.392.392,0,0,1,.092-.541A14.889,14.889,0,0,1,9.625,5.39,16.721,16.721,0,0,1,17.855,7.3a.388.388,0,0,1-.38.677A15.932,15.932,0,0,0,9.625,6.165,14.114,14.114,0,0,0,1.312,8.45a.382.382,0,0,1-.222.07",
    transform: "translate(1.524 11.667)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextbooks);
export default __webpack_public_path__ + "static/media/ic_textbooks.4f7c5f8eff0a1aa6c06427f3e9ccc7e7.svg";
export { ForwardRef as ReactComponent };